import { useState, useRef, useEffect } from "react";
import { OrderItemType } from "../../../types/order";
import styles from "./watch-online.module.scss";



export const WatchOnline = ({ orderItem }: { orderItem: OrderItemType }) => {
    const [isOpen, setIsOpen] = useState(false);
    const videoRef = useRef<HTMLVideoElement>(null);
    const videoUrl = `/video-story/stream/${orderItem.id}`;



    // Handle ESC key to close the video player
    useEffect(() => {
        const handleEscKey = (event: KeyboardEvent) => {
            if (event.key === "Escape" && isOpen) {
                setIsOpen(false);
            }
        };

        window.addEventListener("keydown", handleEscKey);
        return () => {
            window.removeEventListener("keydown", handleEscKey);
        };
    }, [isOpen]);

    // Manage video playback when modal is opened/closed
    useEffect(() => {
        if (isOpen && videoRef.current) {
            videoRef.current.play() 
        } else if (videoRef.current) {
            videoRef.current.pause();
        }
    }, [isOpen, videoUrl]);

    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        setIsOpen(!isOpen);
    };

    return (
        <>
            <div className={styles.video_player} style={{ display: isOpen ? '' : 'none' }}>
                <div className={styles.video_player__content}>
                    <video ref={videoRef} preload="auto" controls playsInline className={styles.video_player__video}>
                        <source src={videoUrl} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                    <button
                        className={styles.video_player__close_button}
                        onClick={handleClick}
                        type="button"
                        aria-label="Close"
                        title="Close"
                    />
                </div>

            </div>
            {!isOpen && <a href="#" className="order__control btn btn_cta btn_lg" onClick={handleClick}>
                <svg role="img" className="btn__ico">
                    <use href="./img/sprite.svg#play"></use>
                </svg>
                Watch online
            </a>}
        </>
    );
};

export default WatchOnline;
